let GmapsCubicBezier = function (
  latlong1,
  latlong2,
  latlong3,
  latlong4,
  resolution,
  map
) {
  var lat1 = latlong1.lat;
  var long1 = latlong1.lng;
  var lat2 = latlong2.lat();
  var long2 = latlong2.lng();
  var lat3 = latlong3.lat();
  var long3 = latlong3.lng();
  var lat4 = latlong4.lat;
  var long4 = latlong4.lng;

  var points = [];

  for (let it = 0; it <= 1; it += resolution) {
    points.push(
      this.getBezier(
        {
          x: lat1,
          y: long1,
        },
        {
          x: lat2,
          y: long2,
        },
        {
          x: lat3,
          y: long3,
        },
        {
          x: lat4,
          y: long4,
        },
        it
      )
    );
  }
  var path = [];
  for (var i = 0; i < points.length - 1; i++) {
    path.push(new google.maps.LatLng(points[i].x, points[i].y));
    path.push(new google.maps.LatLng(points[i + 1].x, points[i + 1].y, false));
  }

  var Line = new google.maps.Polyline({
    path: path,
    geodesic: true,
    strokeOpacity: 0.0,
    icons: [
      {
        icon: {
          path: "M 0,-1 0,1",
          strokeOpacity: 1,
          scale: 2,
        },
        offset: "0",
        repeat: "10px",
      },
    ],
    strokeColor: "black",
  });

  Line.setMap(map);

  return Line;
};

GmapsCubicBezier.prototype = {
  B1: function (t) {
    return t * t * t;
  },
  B2: function (t) {
    return 3 * t * t * (1 - t);
  },
  B3: function (t) {
    return 3 * t * (1 - t) * (1 - t);
  },
  B4: function (t) {
    return (1 - t) * (1 - t) * (1 - t);
  },
  getBezier: function (C1, C2, C3, C4, percent) {
    var pos = {};
    pos.x =
      C1.x * this.B1(percent) +
      C2.x * this.B2(percent) +
      C3.x * this.B3(percent) +
      C4.x * this.B4(percent);
    pos.y =
      C1.y * this.B1(percent) +
      C2.y * this.B2(percent) +
      C3.y * this.B3(percent) +
      C4.y * this.B4(percent);
    return pos;
  },
};

const addMarker = (markerDetails) => {
  const markerView = new window.google.maps.Marker({
    map: markerDetails.map,
    position: markerDetails.position,
    icon: markerDetails.icon,
  });
  return markerView;
};

function showCurvedPath(curvedPathDetails) {
  let projection = curvedPathDetails.map.getProjection(),
    LatLngBounds = google.maps.LatLngBounds,
    Marker = google.maps.Marker,
    Point = google.maps.Point;

  let bounds = new LatLngBounds();
  bounds.extend(curvedPathDetails.origin);
  bounds.extend(curvedPathDetails.destination);
  curvedPathDetails.map.fitBounds(bounds);

  // straight line

  let line = new google.maps.Polyline({
    path: [curvedPathDetails.origin, curvedPathDetails.destination],
    strokeOpacity: 0,
    strokeColor: "grey",
    geodesic: true,
    strokeOpacity: 1.0,
    strokeWeight: 2,
    map: curvedPathDetails.map,
  });

  // curved line 

  var lineLength = google.maps.geometry.spherical.computeDistanceBetween(
    curvedPathDetails.origin,
    curvedPathDetails.destination
  );
  var lineHeading = google.maps.geometry.spherical.computeHeading(
    curvedPathDetails.origin,
    curvedPathDetails.destination
  );
  var curvedLine = new GmapsCubicBezier(
    curvedPathDetails.origin,
    google.maps.geometry.spherical.computeOffset(
      curvedPathDetails.origin,
      lineLength / 3,
      lineHeading - 100
    ),
    google.maps.geometry.spherical.computeOffset(
      curvedPathDetails.destination,
      lineLength / 3,
      -lineHeading + 50
    ),
    curvedPathDetails.destination,
    0.05,
    curvedPathDetails.map
  );
}

const showDrivingDirection = (directionDetails) => {
  let directionsService = new window.google.maps.DirectionsService();
  const lineSymbol = {
    path: "M 0,-1 0,1",
    strokeOpacity: 1,
    scale: 3,
  };
  let directionsDisplay = new window.google.maps.DirectionsRenderer({
    suppressMarkers: true,
    preserveViewport: true,
    polylineOptions: {
      strokeColor: "#999999",
      strokeOpacity: 0,
      icons: [
        {
          icon: lineSymbol,
          offset: "0",
          repeat: "13px",
        },
      ],
    },
  });

  directionsDisplay.setMap(directionDetails.map);
  directionsService.route(
    {
      origin: directionDetails.origin,
      destination: directionDetails.destination,
      travelMode: "DRIVING",
    },
    function (response, status) {
      if (status === "OK") {
        var map1 = directionsDisplay.getMap();
        directionsDisplay.setDirections(response);
        map1.setZoom(13);
      } else {
        window.alert("Directions request failed due to " + status);
      }
    }
  );
};

export default {
  addMarker,
  showDrivingDirection,
  showCurvedPath,
};
